// i18n bootstrap. English is the source-of-truth; French is now fully
// translated for the site shell and page copy. Data-file entries (services,
// conditions, articles, FAQs, prep guides) carry per-object `fr:` overlays
// merged at runtime via `src/data/localize.js`.
//
// To adjust French copy:
//   • UI shell / labels          → /app/frontend/src/i18n/locales/fr.json
//   • Services / Conditions text → /app/frontend/src/data/services.js
//                                  /app/frontend/src/data/conditions.js
//   • FAQ / Prep guides / etc.   → /app/frontend/src/data/faq.js
//                                  /app/frontend/src/data/prepGuides.js
//                                  /app/frontend/src/data/articles.js
//
// Missing French strings gracefully fall back to English.

import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en.json";
import fr from "./locales/fr.json";

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: { translation: en },
            fr: { translation: fr },
        },
        fallbackLng: "en",
        // Empty strings in fr.json should also fall back to en
        returnEmptyString: false,
        interpolation: { escapeValue: false }, // React already escapes
        detection: {
            // Priority: user selection > browser language > default
            order: ["localStorage", "navigator"],
            caches: ["localStorage"],
            lookupLocalStorage: "drk-lang",
            // We only support two languages; anything else falls back to en
            convertDetectedLanguage: (lng) =>
                lng && lng.toLowerCase().startsWith("fr") ? "fr" : "en",
        },
        supportedLngs: ["en", "fr"],
    });

// Keep <html lang> in sync so screen readers, search engines, and browser
// spell-checkers know which language the page is currently in.
function syncHtmlLang(lng) {
    if (typeof document === "undefined") return;
    const short = lng && lng.toLowerCase().startsWith("fr") ? "fr" : "en";
    document.documentElement.setAttribute("lang", short);
}

syncHtmlLang(i18n.resolvedLanguage || i18n.language);
i18n.on("languageChanged", syncHtmlLang);

export default i18n;
